
import {Component, Vue, Prop} from "vue-property-decorator";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";

@Component({
    components: {TooltipDialog}
})
export default class ExportQualité extends Vue {

    @Prop() readonly selectedExportFormat;
    buttonChoiceFormat = [
        {label: "CSV", value: "CSV"},
        // {label: "XLSX", value: "XLSX"}
    ];
    searchContact = "";
    notReady = true;

    created() {
        if (this.selectedExportFormat === null) {
            this.$emit('uploadFormat', this.buttonChoiceFormat[0].value);
        }
    }
}
